import env from '../../../package.json';
import {useToast} from "@chakra-ui/react";
import {APP_CONSTS} from "../../consts";
import {getPrinters} from "../../services/printix-api.service";
import {useDispatch} from "react-redux";
import {setWindowKey} from "../../services/window.service";
import PrintingStatus from "../../components/printing-status/PrintingStatus";
import {useLocalStore} from "@dladio/hooks";
import {printQueueRunner} from "../../services/print-queue-runner.service";
import {checkTokensValidity} from "../../utils";
import {useEffect, useState} from "react";
import {Box, DefaultCommandBar, Stack, TitleBar} from "@dladio/core-ui";
import {InvoiceList, PrintedList, PrinterListDialog} from "../../components";
import {useNavigate} from "react-router-dom";

const PrintQueue = () => {
    const toast = useToast()
    const navigate = useNavigate()
    const dispatch: any = useDispatch()
    const {model: queueStatus} = useLocalStore("queue-status")
    const [showPrinterDialog, setShowPrinterDialog] = useState<boolean>(false)

    useEffect(() => {
        // Token validations
        validateTokens().then()

        // Fetching printers
        dispatch(getPrinters() as any)
    }, [JSON.stringify(checkTokensValidity())])

    setInterval(function () {
        dispatch(getPrinters() as any)
    } as any, 100000)

    const cmdBarConfig = [
        {
            key: 1,
            text: "back",
            iconProps: {iconName: 'Back'},
            onClick: () => navigate(-1)
        },
        {
            key: 2,
            text: 'Start',
            disabled: (queueStatus == APP_CONSTS.PRINT_QUEUE_STATUS.IN_PROGRESS),
            iconProps: {iconName: 'SwitcherStartEnd'},
            onClick: async () => {
                await printQueueRunner(dispatch, toast)
            },
        },
        {
            key: 3,
            text: 'Stop',
            disabled: !(queueStatus == APP_CONSTS.PRINT_QUEUE_STATUS.IN_PROGRESS),
            iconProps: {iconName: 'StopSolid'},
            onClick: async () => {
                toast({
                    title: 'Terminating printing process!',
                    status: 'error',
                    duration: 6000,
                    position: "bottom",
                    isClosable: true,
                })
                setWindowKey(APP_CONSTS.WINDOW_KEYS.EMERGENCY_BREAK, true)
            },
        }
    ]

    const validateTokens = async () => {
        await checkTokensValidity()
    }

    return (
        <>
            <TitleBar title="DLAD Print Queue"
                      subTitle={`Helios core theme v${env?.dependencies?.["@dladio/core-ui"]?.replace('^', '')}`}/>
            <DefaultCommandBar actions={cmdBarConfig}/>

            <Stack>
                <Box title="Invoices">
                    <InvoiceList/>
                </Box>

                <Box title="Printing Status">
                    <PrintingStatus setShowPrinterDialog={setShowPrinterDialog}/>
                </Box>

                <Box title="Printed List">
                    <PrintedList/>
                </Box>
            </Stack>

            <PrinterListDialog
                show={showPrinterDialog}
                setShow={setShowPrinterDialog}/>
        </ >
    );
}


export default PrintQueue